export function removeTrailingSlash(text: string): string {
  return text.replace(/\/$/, '');
}

export function removeLeadingSlash(text: string): string {
  return text.replace(/^\//, '');
}

export function ensureTrailingSlash(text: string): string {
  if (text.endsWith('/')) return text;
  return `${text}/`;
}

export function ensureLeadingSlash(text: string): string {
  return `/${removeLeadingSlash(text)}`;
}

export function escapeHtml(html: string): string {
  const div = document.createElement('div');
  div.textContent = html;
  return div.innerHTML;
}
